import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mass-os-header',
  templateUrl: './mass-os-header.component.html',
  styleUrls: ['./mass-os-header.component.css']
})
export class MassOsHeaderComponent {
  @Input() title = 'Generación masiva OS y OP';
  @Input() subtitle =
    'Carga un file y genera OS (fecha de pago programada) u OP en Alimentos (fecha de revisión).';
  @Input() requirementsLabel = 'Requisitos';
  @Input() serviceCount = 0;
  @Input() selectedCount = 0;

  @Output() showRequirements = new EventEmitter<void>();
}
